import React from "react";

import "@atlaskit/tokens/figma/atlassian-light.json";
import "@atlaskit/tokens/figma/atlassian-dark.json";

import { checkFeatureFlagGate } from "@/utils/feature-flags/check-feature-flag";
import { featureFlags } from "@/utils/feature-flags/feature-flag-manifest";

import { FourOhFourPageTemplate } from "../../../../404/404-page/src/404-page.template";

import { FastshiftDashboardPageTemplateV1 } from "./v1-release/fastshift-dashboard-page-template-v1";
import { FastshiftPortalV2PageRouter } from "./v2-release/fastshift-portal-v2-page-routes";

export const FastshiftDashboardPageTemplate: React.FC = () => {
    const isFastshiftPortalEnabled = checkFeatureFlagGate(
        featureFlags.sxpEnableFastshiftPortal
    );

    if (!isFastshiftPortalEnabled) {
        return <FourOhFourPageTemplate />;
    }

    const isMilestone2Enabled = checkFeatureFlagGate(
        featureFlags.sxpFastshiftPortalMilestone2Gate
    );

    if (isMilestone2Enabled) {
        return <FastshiftPortalV2PageRouter />;
    } else {
        return <FastshiftDashboardPageTemplateV1 />;
    }
};
